var _style, _g, _path, _path2, _path3, _polygon, _polygon2, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLotoLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_3",
    x: "0px",
    y: "0px",
    width: "791px",
    height: "234.5px",
    viewBox: "0 0 791 234.5",
    style: {
      enableBackground: "new 0 0 791 234.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{fill:#FFFFFF;}\n    .st1{fill:#004494;}\n    .st2{fill:#E2001A;}\n    .st3{fill:url(#Path_5_);}\n    .st4{fill:#E1001A;}\n    .st5{fill:#A70000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_x2F_Loto_x2F_Nouveau-Super-Loto"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st0",
    d: "M714.8,66.4c-20,0-38.3,8.1-51.5,21.3c-15.4-27.5-44.7-46.2-78.4-46.2   c-22.8,0-43.6,8.6-59.5,22.6C507.4,32.4,473.2,11,434.2,11c-45.5,0-84.1,29-98.8,69.4c-12.8-9.3-28.4-14.9-45.3-14.9   c-42.6,0-77.4,34.6-77.4,77.4s34.6,77.4,77.4,77.4c27.2,0,51.1-14.1,65-35.5c19.3,22.2,47.7,36.2,79.2,36.2s59.8-14,79.1-36.1   c16.3,21.7,42.4,35.7,71.6,35.7c29.6,0,55.9-14.5,72.2-36.6c13.4,17.2,34.2,28.3,57.6,28.3c40.3,0,73.1-32.8,73.1-73.1   S755.1,66.4,714.8,66.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.568720, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st1",
    d: "M361.4,142.9c0,39.7-32.2,71.9-71.9,71.9s-71.9-32.2-71.9-71.9s32.2-71.9,71.9-71.9    S361.4,103.3,361.4,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    className: "st2",
    d: "M781.9,139.4c0,37.4-30.2,67.6-67.6,67.6s-67.6-30.2-67.6-67.6s30.2-67.6,67.6-67.6    C751.5,71.8,781.9,102,781.9,139.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_4_",
    transform: "translate(9.099526, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M524.1,116.2c0,55-44.6,99.6-99.6,99.6S325,171.2,325,116.2s44.6-99.6,99.5-99.6     C479.5,16.5,524.1,61.1,524.1,116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M659.5,131.1c0,46.4-37.7,84.1-84.1,84.1c-46.4,0-84.2-37.7-84.2-84.1S528.9,47,575.4,47     C621.8,47,659.5,84.7,659.5,131.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "st0",
    d: "M321.2,160.6c-26.8,10.9-36.7,10.7-40.8,3.4c-7.5-13.3-13.5-45.5-15.5-68.2c-7.1,2.2-20.2,9-27.8,13.2    c2.1,35.5,9.3,64.7,18.9,77.5c7.1,9.6,16.8,13.6,28.4,13.6c16.6,0,45.1-13.6,45.1-13.6L321.2,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O_1_",
    className: "st0",
    d: "M425.5,32.5c-38.6,0-72.1,31.3-74.9,69.9c-2.7,38.6,26.3,69.9,65,69.9c38.7,0,72.1-31.3,74.9-69.9    S464.1,32.5,425.5,32.5z M413.3,132.6c-18.6,0-32.6-15-31.2-33.5c1.4-18.6,17.4-33.5,36-33.5c18.6,0,32.6,15,31.2,33.5    C448,117.5,431.9,132.6,413.3,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "st0",
    d: "M643.1,88.4c-33.2-13.6-60.9-19.2-96.8-18.9c-4.9,10.4-9.8,28.5-9.8,28.5c11.2-0.1,22.4,0.6,33.4,1.8    c-4.9,19.9-8.8,40-11.8,60.5c-2.1,14.7,5,26.5,19.7,29.4c4.5,0.9,9,1.7,13.5,2.6c8-27.8,14-56.1,18.1-84.8    c10.7,2.9,21.3,6.4,31.7,10.7C640.9,118.2,643.7,104.1,643.1,88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "st0",
    d: "M715.9,100.8c-23.9,7-37.6,32.1-30.7,55.9c7,23.9,31.9,37.6,55.9,30.7c23.9-7,37.6-32.1,30.7-55.9    C764.8,107.6,739.7,93.9,715.9,100.8z M739.1,165.9c-11.5,3.3-23.6-3.2-26.9-14.7c-3.3-11.5,3.2-23.6,14.7-26.9    c11.5-3.3,23.6,3.2,26.9,14.7C757.3,150.4,750.7,162.5,739.1,165.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 8.530806)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7_",
    className: "st0",
    d: "M74.8,200.8l-64.4-64.4c-9.9-9.9-9.9-26.2,0-36.1l64.4-64.4c9.9-9.9,26.2-9.9,36.1,0l64.4,64.4   c9.9,9.9,9.9,26.2,0,36.1L111,200.8C101,210.7,84.8,210.7,74.8,200.8z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.710900, 0.853081)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 2591.7974,
    y1: 213.3819,
    x2: 2583.1062,
    y2: 213.3819,
    gradientTransform: "matrix(19.2636 0 0 19.2654 -49754.957 -3993.4741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#009EDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#0381C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#0064AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5008,
    style: {
      stopColor: "#004E9B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#004694"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004492"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8_",
    className: "st3",
    d: "M14.4,104.1l64.4-64.4c7.4-7.4,19.3-7.4,26.7,0l64.4,64.4c7.4,7.4,7.4,19.3,0,26.7l-64.2,64.4    c-7.4,7.4-19.3,7.4-26.7,0l-64.4-64.4C7,123.4,7,111.4,14.4,104.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st0",
    d: "M144.6,98.1c-0.4-1.1-0.1-18.6-12.5-20.2c-8.1-1.1-15.5,4.4-21.1,11.4l24.9,11.9L124,126.2    c9,2,18.3,1.6,23.9-4.5C156.3,112.3,145,99.2,144.6,98.1z M95.9,122.5c-5.2,2.3-21.7,34.8-7.7,48c9.1,8.6,22.5-2.6,23.5-3.1    c1.1-0.4,18.6,0.1,20.3-12.4C134.7,136,101.4,121.2,95.9,122.5z M91.8,110.8c5.2-2.3,21.7-34.8,7.7-48c-9.1-8.6-22.5,2.6-23.6,3.1    c-1.1,0.4-18.6-0.1-20.3,12.4C53,97.2,86.4,112.2,91.8,110.8L91.8,110.8z M87.7,118.6c-2.3-5.2-34.8-21.7-48-7.7    c-8.6,9.1,2.6,22.5,3.1,23.5c0.4,1.1-0.1,18.6,12.4,20.3C74.2,157.3,89.1,124,87.7,118.6L87.7,118.6z M59.4,168.6l6.6,6.6    c4.4-4.5,9.9-12.4,12.3-24.2c-0.5-0.1-3.6-0.5-3.9-0.6C71.1,159.6,64.5,165.3,59.4,168.6L59.4,168.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    className: "st4",
    points: "98.2,114.5 109.2,91.6 132.2,102.6 121.2,125.5   "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_1_",
    className: "st5",
    points: "108,94.3 109.2,91.6 132.2,102.6 130.9,105.3   "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_2_",
    className: "st5",
    points: "98.3,114.6 109.3,91.6 112.1,92.9 101.1,115.9   "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotoLarge);
export default __webpack_public_path__ + "static/media/loto-large.3f8806aa14f4165d4e53ab5d54683cad.svg";
export { ForwardRef as ReactComponent };